import {
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { IResourceComponentsProps, useShow } from "@refinedev/core";
import { DateField, NumberField, Show } from "@refinedev/mui";

export const CreditShow: React.FC<IResourceComponentsProps> = () => {
  const { queryResult } = useShow();
  const { data, isLoading } = queryResult;

  const record: any = data;

  console.log({ record });

  return (
    <Show isLoading={isLoading}>
      <Stack gap={1}>
        <Typography variant="body1" fontWeight="bold">
          Id
        </Typography>
        <NumberField value={record?.id ?? ""} />
        <Typography variant="body1" fontWeight="bold">
          Created At
        </Typography>
        <DateField value={record?.createdAt} />
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Credit</TableCell>
                <TableCell>Marchandise</TableCell>
                <TableCell>Consigne</TableCell>
                <TableCell>Total Credit</TableCell>
                <TableCell>Espece</TableCell>
                <TableCell>Consigne</TableCell>
                <TableCell>Total Payee</TableCell>
                <TableCell>Reste</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(record?.data?.creditsData || [])?.map(
                (item: any, index: number) => (
                  <TableRow key={index}>
                    <TableCell>{item.credit.name}</TableCell>
                    <TableCell>{item.credit.credit}</TableCell>
                    <TableCell>{item.credit.marchandise}</TableCell>
                    <TableCell>{item.credit.consigne}</TableCell>
                    <TableCell>{item.credit.total_credit}</TableCell>
                    <TableCell>{item.payment.espece}</TableCell>
                    <TableCell>{item.payment.consigne}</TableCell>
                    <TableCell>{item.payment.total_payee}</TableCell>
                    <TableCell>{item.reste}</TableCell>
                  </TableRow>
                )
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
    </Show>
  );
};
